// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__ap652","inner":"Footer_inner__37ZHH"};